<template>
  <div>
    <fob-aboutme-list-options :resourceType="resourceType"></fob-aboutme-list-options>
    <fob-aboutme-list-compact :resourceType="resourceType"></fob-aboutme-list-compact>
  </div>
</template>

<script>

import AboutMeListCompact from '@/components/aboutme/AboutMeListCompact'
import AboutMeListOptions from '@/components/aboutme/AboutMeListOptions'

export default {
  name: 'fob-aboutme-list-view',
  props: ['resourceType'],
  components: {
    'fob-aboutme-list-compact': AboutMeListCompact,
    'fob-aboutme-list-options': AboutMeListOptions
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/aboutme/AboutMeListView.vue